// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';
import {identifierMarkdocFunctionToPlaceholder} from '../../components/core/Identifier/identifierMap';

// This can only be used inside of code gen snippets.
export const identifier: MarkdocFunctionSchema = {
  render(parameters): string {
    if (parameters['0']) {
      const id: string = parameters['0'];
      return identifierMarkdocFunctionToPlaceholder(id);
    } else {
      // TODO: we should add markdoc validation for functions.
      return '{{RESOURCE_ID}}';
    }
  },
};
